module.exports = __webpack_public_path__ + "img/DE02061.edb8fe17.png";